import React from "react"
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'
import Header from "../Header/Header"
import "./Home.css"

export default function Home() {
    let branch = window?.location?.hash?.replace('#', '') || ''

    return (
        <>
            <Container fluid className="vms-checkin-container">
                <Row>
                    <Col className="p-0">
                        <Header />
                    </Col>
                </Row>
                <div className="vms-checkin-wrapper">
                    <h2 className="text-center">Welcome to <strong>VGM</strong> </h2>
                    <Row className={`justify-content-center`}>
                        <Col lg={4} md={4}>
                            <Link to={`/checkin#${branch}`} >
                                <div className="box" >
                                    <i className="fa fa-check-circle fa-5x"></i>
                                    <h4>Checkin</h4>
                                </div>
                            </Link>
                        </Col>
                        {!(window.location.pathname.includes("checkin") || window.location.pathname.includes("queue") || window.location.pathname === "/") && (
                            <Col lg={4} md={4}>
                                <Link to={`/admin#${branch}`} >
                                    <div className="box">
                                        <i className="fa fa-user fa-5x"></i>
                                        <h4>Admin Panel</h4>
                                    </div>
                                </Link>
                            </Col>
                        )}
                        <Col lg={4} md={4}>
                            <Link to={`/queue#${branch}`} >
                                <div className="box">
                                    <i className="fa fa-list fa-5x"></i>
                                    <h4>Drivers Queue</h4>
                                </div>
                            </Link>
                        </Col>
                    </Row>

                </div>
            </Container>
        </>
    )
}